import { render, staticRenderFns } from "./PhDTheses.vue?vue&type=template&id=541c01cb&"
import script from "./PhDTheses.vue?vue&type=script&lang=js&"
export * from "./PhDTheses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports